// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.product.ProductInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { ProductVersion } from "abweb/dto/generated/product/ProductVersion";
import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
import { ProductInfoItem } from "abweb/dto/product/ProductInfoItem";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class ProductInfoBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createProductInfoBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadp.ProductInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initProductInfo(json.allowGuestAccess != null ? json.allowGuestAccess : null, json.buildID != null ? json.buildID : null, json.date != null ? json.date : null, json.helpModule != null ? json.helpModule : null, json.items != null ? TSOGUtils.decodeObjectArray(json.items, ProductInfoItem, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "items")) : null, json.name != null ? json.name : null, TSOGUtils.decodeObject(json.productVersion, ProductVersion, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "productVersion")), json.usesUserAuthentication != null ? json.usesUserAuthentication : null, json.version != null ? json.version : null);
  }
  initProductInfo(allowGuestAccess, buildID, date, helpModule, items, name, productVersion, usesUserAuthentication, version) {
    this.initKendoObservableObjectProxy();
    this._allowGuestAccess = allowGuestAccess;
    this._buildID = buildID;
    this._date = date;
    this._helpModule = helpModule;
    this._items = items;
    this._name = name;
    this._productVersion = productVersion;
    this._usesUserAuthentication = usesUserAuthentication;
    this._version = version;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["allowGuestAccess"] = this._allowGuestAccess;
    retVal["buildID"] = this._buildID;
    retVal["date"] = this._date;
    if (this._helpModule != null) {
      retVal["helpModule"] = this._helpModule;
    }
    if (this._items != null) {
      retVal["items"] = TSOGUtils.toTSOGArray(this._items, serializeContext);
    }
    retVal["name"] = this._name;
    if (this._productVersion != null) {
      retVal["productVersion"] = TSOGUtils.toTSOGNativeObject(this._productVersion, serializeContext);
    }
    retVal["usesUserAuthentication"] = this._usesUserAuthentication;
    retVal["version"] = this._version;
    return retVal;
  }
  get allowGuestAccess() {
    return this._allowGuestAccess;
  }
  set allowGuestAccess(value) {
    this._allowGuestAccess = value;
  }
  get buildID() {
    return this._buildID;
  }
  set buildID(value) {
    this._buildID = value;
  }
  get date() {
    return this._date;
  }
  set date(value) {
    this._date = value;
  }
  get helpModule() {
    return this._helpModule;
  }
  set helpModule(value) {
    this._helpModule = value;
  }
  get items() {
    return this._items;
  }
  set items(value) {
    this._items = value;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get productVersion() {
    return this._productVersion;
  }
  set productVersion(value) {
    this._productVersion = value;
  }
  get usesUserAuthentication() {
    return this._usesUserAuthentication;
  }
  set usesUserAuthentication(value) {
    this._usesUserAuthentication = value;
  }
  get version() {
    return this._version;
  }
  set version(value) {
    this._version = value;
  }
}
//# sourceMappingURL=ProductInfoBase.js.map
